import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";

import { lenis } from "../global/scroll";

gsap.registerPlugin(ScrollTrigger, SplitText);

export default class AnimationHandler {
	search() {
		gsap.utils.toArray('[data-search="trigger"]').forEach((e, index) => {
			e.addEventListener('click', () => {
				const container = document.querySelector('[data-search="container"]');
				container.classList.toggle('is-active');
				if (container.classList.contains('is-active')) {
					lenis.stop();
				} else {
					lenis.start();
				}
			});
		});
	}

	parrallax() {
		gsap.utils.toArray('[data-parrallax="container"]').forEach((e) => {
			if (e.firstElementChild) {
				const rect = e.getBoundingClientRect();
				const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
				
				const object = e.firstElementChild;
				const amount = e.getAttribute('data-parrallax-speed');
				
				const pixelAmount = e.offsetHeight * (amount / 100);
				const isAboveTheFold = rect.top + scrollTop < window.innerHeight;
				
				object.style.willChange = "transform";
				gsap.fromTo(object, {
					y: isAboveTheFold ? '0' : pixelAmount,
				}, {
					y: isAboveTheFold ? pixelAmount : pixelAmount * -1,
					force3D: true,
					ease: "none",
					scrollTrigger: {
						trigger: e,
						scrub: true,
						start: isAboveTheFold ? "top top" : "top bottom",
						end: isAboveTheFold ? "bottom top" : "bottom top",
					},
				});
			}
		});
	}
	
	resize() {
		// add for desktop only
		// window.addEventListener("resize", () => {
		// 	ScrollTrigger.refresh();
		// });
	}
	
	headerScroll() {
		const header = document.querySelector('header');
		const secondary = header.querySelector('[data-header="secondary"]');
		let height = 0;
		
		if (secondary) {
			height = secondary.getBoundingClientRect().height;
		}
		
		ScrollTrigger.create({
			trigger: header,
			start: "100% top",
			onEnter: () => {
				secondary && (header.style.transform = `translateY(-${height}px)`);
				header.classList.add('bg-darkBlue');
			},
			onLeaveBack: () => {
				secondary && (header.style.transform = "translateY(0)");
				header.classList.remove('bg-darkBlue');
			}
		});
	} 
	
	headerNavigation() {
		const header = document.querySelector('header');
		gsap.utils.toArray(header.querySelectorAll('.menu-item-has-children')).forEach((e) => {
			e.addEventListener('mouseenter', () => {
				e.classList.add('is-hover');
				lenis.stop();
			});
			e.addEventListener('mouseleave', () => {
				e.classList.remove('is-hover');
				lenis.start();
			});
		});
		
		gsap.utils.toArray(header.querySelectorAll('[data-navigation="trigger"]')).forEach((e) => {
			e.addEventListener('click', () => {
				header.querySelector('.main-menu').classList.toggle('is-active');
				if (header.querySelector('.main-menu').classList.contains('is-active')) {
					e.textContent = 'Close';
				} else {
					e.textContent = 'Menu';
				}
			});
		});
	}
	
	loading() {
		setTimeout( () => {
			document.body.setAttribute('data-loading', 'loaded');
		}, 100)
	}
	
	anchorPoints() {
		const anchorLinks = document.querySelectorAll('[anchor-point="link"]');
		const headerHeight = document.querySelector('header').offsetHeight;
		anchorLinks.forEach(link => {
			link.addEventListener('click', (e) => {
				e.preventDefault();
				const targetId = e.target.getAttribute('href').substring(1);
				const targetElement = document.getElementById(targetId);
				if (targetElement) {
					lenis.scrollTo(targetElement, {offset: -headerHeight});
					document.querySelector('header').querySelector('.menu-main-navigation-container').classList.add('translate-x-full');
				}
			});
		});
	}
	
	animations() {
		gsap.utils.toArray('[data-animate="opacity"]').forEach( (e) => {
			const delay = 
				e.dataset.animateDelayDesktop || 
				e.dataset.animateDelayMobile || 
				(e.offsetTop < window.innerHeight ? e.dataset.animateDelay || "0.5" : e.dataset.animateDelay || "0");
			
			const duration = 
				e.dataset.animateDurationDesktop || 
				e.dataset.animateDurationMobile || 
				e.dataset.animateDuration || 
				"2";
			
			const stagger = 
				e.dataset.animateStaggerDesktop || 
				e.dataset.animateStaggerMobile || 
				e.dataset.animateStagger || 
				"0.1";
				
			var tl = gsap.timeline({
				scrollTrigger: {
					trigger: e,
					start: "top bottom",
				},
				onComplete: () => {
					// gsap.set(e, { clearProps: "all" });
				}
			});	
			tl.fromTo(e, {
				autoAlpha: 0,
			}, {
				autoAlpha: 1,
				ease: "power4.out",
				duration: duration,
				stagger: stagger,
				delay: delay,
			});
		});
		gsap.utils.toArray('[data-animate="text"]').forEach((e) => {
			document.fonts.ready.then(() => {
				const delay =
					e.dataset.animateDelayDesktop ||
					e.dataset.animateDelayMobile ||
					(e.offsetTop < window.innerHeight ? e.dataset.animateDelay || "0.5" : e.dataset.animateDelay || "0");
		
				const duration =
					e.dataset.animateDurationDesktop ||
					e.dataset.animateDurationMobile ||
					e.dataset.animateDuration ||
					"1";
		
				const stagger =
					e.dataset.animateStaggerDesktop ||
					e.dataset.animateStaggerMobile ||
					e.dataset.animateStagger ||
					"0.1";
		
				if (!e.matches('p, h1, h2, h3, h4, h5, h6, span, strong, em')) {
					gsap.utils.toArray(e.querySelectorAll('p, h1, h2, h3, h4, h5, h6, span, strong, em')).forEach((child) => {
						animateText(child, delay, duration, stagger);
					});
				} else {
					animateText(e, delay, duration, stagger);
				}
			});
			function animateText(element, delay, duration, stagger) {
				const inner = new SplitText(element, {
					type: "lines, words",
					linesClass: "lines--inner"
				});
				const outer = new SplitText(element, {
					type: "lines, words",
					linesClass: "lines--outer"
				});
			
				const tl = gsap.timeline({
					scrollTrigger: {
						trigger: element,
						start: "top bottom",
					},
					onComplete: () => {
						const height = inner.lines[0].offsetHeight;
						outer.revert();
						inner.revert();
						gsap.set(element, { y: height / -10 });
					}
				});
			
				tl.set(element, { opacity: 1 });
				tl.fromTo(
					inner.lines,
					{
						yPercent: -100,
						opacity: 0,
					},
					{
						yPercent: -10,
						opacity: 1,
						ease: "power4.out",
						duration: duration,
						stagger: stagger,
						delay: delay,
					}
				);
			}
		});
		
		gsap.utils.toArray('[data-animate="scale"]').forEach( (e) => {
			const delay = 
				e.dataset.animateDelayDesktop || 
				e.dataset.animateDelayMobile || 
				(e.offsetTop < window.innerHeight ? e.dataset.animateDelay || "0.5" : e.dataset.animateDelay || "0");
			
			const duration = 
				e.dataset.animateDurationDesktop || 
				e.dataset.animateDurationMobile || 
				e.dataset.animateDuration || 
				"2";
			
			const stagger = 
				e.dataset.animateStaggerDesktop || 
				e.dataset.animateStaggerMobile || 
				e.dataset.animateStagger || 
				"0.1";
			
			const tl = gsap.timeline({
				scrollTrigger: {
					trigger: e,
					start: "top bottom",
				},
			});
			
			tl.fromTo(e, {
				autoAlpha: 0,
				scale: 1.2,
				filter: "blur(5vw)"
			}, {
				autoAlpha: 1,
				scale: 1,
				filter: "blur(0vw)",
				ease: "power4.out",
				duration: duration,
				stagger: stagger,
				delay: delay,
			});
		});
	}
}